import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Dashboard = lazy(() => import("../pages/dashboard"));
const AllCreatives = lazy(() => import("../pages/content-listing"));
const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const UploadCreative = lazy(() => import("../pages/upload-content"));
const ContentSearch = lazy(() => import("../pages/search"));
const MyContent = lazy(() => import("../pages/my-content"));
const Content = lazy(() => import("../pages/content"));
const Brand = lazy(() => import("../pages/brand"));
const ContentTree = lazy(() => import("../pages/content-tree"));
const Research = lazy(() => import("../pages/research"));
const ContentUsageDetails = lazy(() =>
  import("../pages/content-usage-details")
);

export const ContentLibraryRouter = [
  {
    path: "content-library",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: "my-content",
        element: (
          <Suspense fallback={<Backdrop />}>
            <MyContent />
          </Suspense>
        ),
      },
      {
        path: "research",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Research />
          </Suspense>
        ),
      },
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllCreatives />
          </Suspense>
        ),
      },
      {
        path: "upload",
        element: (
          <Suspense fallback={<Backdrop />}>
            <UploadCreative />
          </Suspense>
        ),
      },
      {
        path: "search",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ContentSearch />
          </Suspense>
        ),
      },
      {
        path: "category/:file_type",
        element: (
          <Suspense fallback={<Backdrop />}>
            <MyContent />
          </Suspense>
        ),
      },
      {
        path: "advanced/content/:type",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Content />
          </Suspense>
        ),
      },
      {
        path: "advanced/brand/:type",
        element: (
          <Suspense fallback={<Backdrop />}>
            <Brand />
          </Suspense>
        ),
      },
      {
        path: "advanced/content-tree",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ContentTree />
          </Suspense>
        ),
      },
      {
        path: "content-usage-detail/:keyword",
        element: (
          <Suspense fallback={<Backdrop />}>
            <ContentUsageDetails />
          </Suspense>
        ),
      },
    ],
  },
];
